import { Controller } from "@hotwired/stimulus"

// Grows a textarea with its content so it never scrolls internally. Pair with
// `overflow-hidden` (and `field-sizing-content` where supported) on the element.
export default class extends Controller {
  connect() {
    this.resize = this.resize.bind(this)
    this.element.addEventListener('input', this.resize)
    window.addEventListener('resize', this.resize)

    // Re-measure once width is known: the modal injects this form while hidden,
    // and the width can change later (modal transition, viewport resize).
    if (typeof ResizeObserver !== 'undefined') {
      this.lastWidth = null
      this.resizeObserver = new ResizeObserver(entries => {
        const width = entries[0].contentRect.width
        if (width === this.lastWidth) return
        this.lastWidth = width
        // Deferred: changing the height inside the observer callback would
        // trigger a "ResizeObserver loop" error.
        window.cancelAnimationFrame(this.frame)
        this.frame = window.requestAnimationFrame(this.resize)
      })
      this.resizeObserver.observe(this.element)
    }

    this.resize()
    this.frame = window.requestAnimationFrame(this.resize)
  }

  disconnect() {
    this.element.removeEventListener('input', this.resize)
    window.removeEventListener('resize', this.resize)
    this.resizeObserver?.disconnect()
    window.cancelAnimationFrame(this.frame)
  }

  resize() {
    if (!this.element.isConnected || this.element.offsetParent === null) return

    this.element.style.height = 'auto'
    this.element.style.height = this.element.scrollHeight + 'px'
  }
}
